function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/accounts-receivable/deposits';

export default {
    data: function data() {
        return {
            headers: ['ID', { title: 'Date', filter: 'dateFull' }, 'Count', { title: 'Total', filter: 'toCurrency' }],
            fields: ['id', 'post_date', "payment_count", "total"],
            items: [],
            filterKey: '',
            selectedDeposit: false
        };
    },
    mounted: function mounted() {

        var $el = this;

        Event.$on('refresh-ar-deposits', function () {
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var search = arguments[1];
            var sort = arguments[2];
            var order = arguments[3];
            var isDate = arguments[4];

            $el.load(offset, search, sort, order, isDate);
        });

        Event.$on('close-flyout', function () {
            $el.selectedDeposit = false;
        });
    },


    methods: {
        load: function load(offset) {
            var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
            var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DESC';
            var isDate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;


            Event.$emit('data-table-loading');

            var self = this;
            var data = {
                offset: offset,
                search: search,
                sort: sort,
                order: order,
                isDate: isDate
            };

            axios.post(BASE_URL + '/list', data).then(function (response) {

                offset !== 0 ? self.items = [].concat(_toConsumableArray(self.items), _toConsumableArray(response.data)) : self.items = response.data;

                Event.$emit('data-table-loaded');
            });
        },
        add: function add() {
            Event.$emit('ar-add-deposit');
        },
        viewDetails: function viewDetails(deposit) {
            Event.$emit('view-deposit', deposit);
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-receivable/deposits/DepositList.vue
// module id = UqlV
// module chunks = 0 1